import React from 'react';
import { LinearProgress } from '@mui/material';

import './LinearProgress.module.scss';

const MLLinearProgress = ({
  progress,
  progressType = '',
  classList = 'status-default',
}) => {
  return (
    <div className={`flex items-center line-progress-bar ${classList}`}>
      {progressType === 'percentageProgress' ? (
        <div className="w-full">
          <div className={`h-6 w-full relative`}>
            <div
              style={{ width: progress }}
              className={`absolute transition-all top-0 left-0 h-full text-[var(--White)] text-base leading-[19px] flex items-center justify-end`}
            >
              <span
                className={`${
                  parseFloat(progress) > 8
                    ? 'px-2'
                    : 'absolute left-2 top-0 h-full flex items-center text-[var(--White)] text-base leading-[19px]'
                }`}
              >
                {progress}
              </span>
            </div>
          </div>
        </div>
      ) : (
        <LinearProgress
          className={`w-full h-4 ${classList}`}
          variant="determinate"
          value={progress}
        />
      )}
    </div>
  );
};

export default MLLinearProgress;
